import { Component, OnInit } from '@angular/core';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { OrderListItemModel } from 'src/app/models/order/order-list-item.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePagedPage } from '../base-paged-page';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
    standalone: false
})
export class OrdersComponent extends BasePagedPage<string, OrderListItemModel> implements OnInit {

  public constructor(private mApiService: ApiService) {
    super();
    this.pageSize = 20;
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public getData(page?: number): void {

    if (!page) {
      return;
    }
    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<OrderListItemModel>>('/api/admin/orders', {
      page: page,
      pageSize: this.pageSize,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        r.items.forEach(x => x.utcDate += '+00:00');

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }
}
